module.exports = __webpack_public_path__ + "img/shield-logo-web_1.315850a7.svg";